import type { BusinessProfile, ParsedStripeErrors } from "../types";
import {
  capabilityStyle,
  merchantCapabilities,
  type Capability,
} from "./capabilities";
import { SidebarSection } from "./SidebarSection";

export function CapabilityPill({ capability }: { capability: Capability }) {
  return (
    <span
      className={`shrink-0 rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${capabilityStyle(capability.status)}`}
    >
      {capability.status}
    </span>
  );
}

/**
 * What this merchant can actually do right now.
 *
 * Two rows, because two questions account for most of why anyone opens a
 * merchant: can they take money, and can they receive it. The reason a
 * capability is off lives in the overlay — the card answers the question,
 * the overlay explains it.
 */
export function CapabilitiesCard({
  business,
  stripeErrors,
  onViewAll,
}: {
  business: BusinessProfile;
  stripeErrors: ParsedStripeErrors | null;
  onViewAll: () => void;
}) {
  const capabilities = merchantCapabilities(business, stripeErrors);

  return (
    <SidebarSection title="Capabilities" onViewAll={onViewAll}>
      {capabilities.map((capability) => (
        <div
          key={capability.name}
          className="flex items-center justify-between gap-3"
        >
          <span className="text-foreground text-sm">{capability.name}</span>
          <CapabilityPill capability={capability} />
        </div>
      ))}
    </SidebarSection>
  );
}
